import { DynamicLoaderRegistry, ColorFrom } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { AngleFrom, NumberInputFrom } from '@tencent/wb-ext-form';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import { IDirection, IFillGradualValues } from '@framework/workbench/drawer/ui/text/fill/fill-interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IChartLineFeature extends IBaseDrawerFeature {
    curBorderType: string;
    borderColor: ITDColor;
    width: number;
    opacity: number;
    style: any;
    borderGradualValues: IFillGradualValues;
    readonly borderInfo: any;
    readonly borderType: string;
    // getSolidFillColorOptions();
    renderBorderLine(): ReactElement;
    handleBorderTypeChange(value);
    handleBorderWidthChange(value, onlyChangeUI?);
    changeBorderColor(tdColor: ITDColor, from: ColorFrom);
    handleOpacityChange(value, onlyChangeUI, from?: NumberInputFrom);
    updateUIWithBorderData();
    renderGradualFill(): ReactElement;
    handleGradualTypeChange(type: string): void;
    handleGradualAngleChange(value: number, from?: AngleFrom, isDragging?: boolean): void;
    handleGradualDirectionChange(value: IDirection): void
    handleGradualOpacityChange(opacity: number, from?: NumberInputFrom, onlyChangeUI?: boolean): void;
    getFillDirectionOptions();
    shouldAngleDisabled(): boolean;
    getColorSelectButton(): JSX.Element;
}

export const IChartLineFeature = Symbol.for('chart-line-feature');

DynamicLoaderRegistry.merge(IChartLineFeature, {
    useFactory: async () => {
        const { ChartLineFeature } = await import('./line-feature');
        return ChartLineFeature;
    },
    on: loadTask,
});
